  <div class="row">
  <div class="container d-flex justify-content-center">
    <div class="form-group w-100">
      <div matAutocompleteOrigin #origin="matAutocompleteOrigin">
        <div
          class="d-flex justify-content-center align-items-center search-bar-custom"
        >
          <input
            class="no-border-input"
            [matAutocompleteConnectedTo]="origin"
            matAutocompletePosition="below"
            (keyup.enter)="search()"
            [matAutocomplete]="auto"
            (input)="getSuggestions()"
            [(ngModel)]="data"
            i18n-placeholder="campo di ricerca|Placeholder @@result-page.search-bar.placeholder"
            placeholder="Ricerca un principio attivo, casa farmaceutica, medicinale, descrizione ATC e codice AIC"
            aria-label="Ricerca un principio attivo, casa farmaceutica, medicinale, descrizione ATC e codice AIC "
          />
          <svg class="icon d-block me-5" (click)="search()">
            <use href="/assets/icons/sprites.svg#it-search"></use>
          </svg>
          <mat-autocomplete
            [class]="'result-page-autocomplete'"
            #auto="matAutocomplete"
          >
            <mat-option
              *ngFor="let x of suggests"
              [value]="x"
              (click)="selectSuggestion(x)"
            >
              {{ x }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
    </div>
  </div>
</div>
